type TableSlot = 'wrapper' | 'table' | 'thead' | 'tbody' | 'tr' | 'th' | 'td'

/**
 * HeroUI Table classNames that turn each row into a card on a phone: the header
 * row hides and the cells wrap side by side under each other, instead of the
 * table running off the screen. Desktop is untouched.
 *
 * CSS only, so a table keeps one set of rows and its tests see the same DOM.
 * Pass the table's own classNames to merge them.
 */
export function stackOnPhone(
  own: Partial<Record<TableSlot, string>> = {},
): Partial<Record<TableSlot, string>> {
  const phone: Record<TableSlot, string> = {
    wrapper: 'max-md:p-3',
    table: 'max-md:block',
    thead: 'max-md:hidden',
    tbody: 'max-md:block',
    tr: 'max-md:flex max-md:flex-wrap max-md:items-center max-md:gap-x-3 max-md:gap-y-1.5 max-md:border-b max-md:border-divider max-md:py-3 max-md:last:border-b-0',
    th: '',
    td: 'max-md:block max-md:p-0 max-md:before:hidden',
  }
  const merged: Partial<Record<TableSlot, string>> = {}
  for (const slot of Object.keys(phone) as TableSlot[]) {
    const value = [own[slot], phone[slot]].filter(Boolean).join(' ')
    if (value) merged[slot] = value
  }
  return merged
}
